module.exports = __webpack_public_path__ + "static/media/assign-budget.384d3263.svg";